<template>
  <div>
    <template v-if="isFundDataLoading">
      <mds-loader />
    </template>
    <template v-else>
      <div class="fund-replacement-container">
        <div class="action-fund-details">
          <div class="action-fund-heading">Action Fund Details :</div>
          <mds-table class="action-fund-table">
            <mds-thead>
              <mds-th style="width:20px"> </mds-th>
              <mds-th> Status </mds-th>
              <mds-th> Pending </mds-th>
              <mds-th> Fund Name </mds-th>
              <mds-th> Ticker </mds-th>
              <mds-th> Sec ID </mds-th>
              <mds-th> Category </mds-th>
            </mds-thead>
            <mds-tbody>
              <mds-tr class="fund-replacement-row">
                <mds-td class="fund-replacement-column" style="width:20px">  </mds-td>
                <mds-td class="fund-replacement-column">
                  <status-icons
                    :status="[
                      { name: actionFundDetails.pendingStatus.name },
                    ]"
                  />
                </mds-td>
                <mds-td class="fund-replacement-column">  </mds-td>
                <mds-td class="fund-replacement-column"> {{actionFundDetails.displayName}} </mds-td>
                <mds-td class="fund-replacement-column"> {{actionFundDetails.ticker}} </mds-td>
                <mds-td class="fund-replacement-column"> {{actionFundDetails.secID}} </mds-td>
                <mds-td class="fund-replacement-column"> {{actionFundDetails.psaCategory.name}} </mds-td>
              </mds-tr>
            </mds-tbody>
          </mds-table>
        </div>
        <!-- <fund-replacement-details :actionFundDetails="actionFundDetails"></fund-replacement-details> -->
      </div>
    </template>
  </div>
</template>

<script>

import {
  MdsTable, MdsThead, MdsTh, MdsTbody, MdsTr, MdsTd,
} from '@mds/data-table';
import StatusIcons from '@/components/atoms/StatusIcons';
import { mapState } from 'vuex';
import fundData from '@/config/fund-replacement-data.json';

export default {
  name: 'SelectFundReplacement',
  components: {
    MdsTable,
    MdsThead,
    MdsTh,
    MdsTbody,
    MdsTr,
    MdsTd,
    StatusIcons,
  },
  data() {
    return {
      isFundDataLoading: false,
      actionFundDetails: null,
    };
  },
  computed: {
    ...mapState({
      selectedClient: (state) => state.grid.client.selected,
    }),
  },
  created() {
    this.loadFundDetails();
  },
  methods: {
    backHandler() {
      if (this.selectedClient) {
        this.$router.push(
          {
            name: 'clientGrid',
            params: { clientId: this.selectedClient },
          },
        );
      } else {
        this.$router.push({ name: 'grid' });
      }
    },
    loadFundDetails() {
      this.actionFundDetails = fundData;
    },
  },
};
</script>

<style lang="scss">
.fund-replacement-container {
  padding: $mds-space-4-x;
  .action-fund-table {
    width: 80%;
    margin: auto;
  }
  .action-fund-heading {
    @include mds-level-6-heading($bold: true);
  }
  .fund-replacement-column {
    background-color: $mds-background-color-alternative-row-on-light;
    padding: $mds-space-2-x 0;
  }
}
</style>
